import React from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import EventAgenda from "components/agenda";

const EventAgendaPage = ({ location: { search }, history }) => (
  <Dashboard>
    <PageHeaderBar showBackButton title="app.page.event.agenda" />
    <PageSection spaced hideBackground>
      <EventAgenda />
    </PageSection>
  </Dashboard>
);

export default EventAgendaPage;
